/**
 * @prettier
 */

// React Packages
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import { countError } from "../../state/actions/configActions";
import i18next from "i18next";

// Components
import CustomButton from "../../components/CustomButton";

// Helpers
import { hideReconnecting, genericErrors } from "../../services/shared/helpers";

// Config
import { ACTION_LABELS } from "../../config/dataDogActionLabels";
const ACTION = ACTION_LABELS.errors;

class Error extends Component {
    constructor(props) {
        super(props);
        this.primaryFocusRef = React.createRef();
        this.lastFocusViewKey = null;
        this.state = {
            max: 3, //Max allowed retries
        };
    }

    componentDidMount() {
        // Count how many times we've encountered an error this session
        this.props.countError();

        // Hide reconnecting message if shown
        hideReconnecting();

        // Set document title
        const { t } = this.props;
        document.title = t("idpal_doc_title_error");
        this.applyFocusIfNeeded();
    }

    getFocusViewKey() {
        const showRetry =
            this.allowRetry() &&
            (this.isNetworkError() || !this.props.isLimitReached);
        return showRetry ? "retry" : "contact";
    }

    applyFocusIfNeeded() {
        const viewKey = this.getFocusViewKey();
        if (viewKey !== this.lastFocusViewKey && this.primaryFocusRef?.current) {
            this.primaryFocusRef.current.focus();
            this.lastFocusViewKey = viewKey;
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.isLimitReached !== this.props.isLimitReached ||
            prevProps.errors !== this.props.errors ||
            prevProps.error !== this.props.error
        ) {
            this.applyFocusIfNeeded();
        }

        const { t } = this.props;
        document.title = t("idpal_doc_title_error");
    }

    isNetworkError() {
        if (this.props.error != null) {
            if (this.props.error.message === "Network Error") {
                return true;
            }
        }
        return false;
    }

    allowRetry() {
        if (!this.props.retryAction) {
            return false;
        }

        if (this.props.errors > this.state.max && !this.isNetworkError()) {
            return false;
        }
        return true;
    }

    getContact() {
        if (this.props.branding) {
            return this.props.branding.data.company_branding
                .costumer_support_email;
        } else {
            return i18next.t("idpal_an_administrator");
        }
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="error-overlay">
                    <div className="error-page">
                        {/* Max retries not hit, and we have a function to retry, allow user to retry */}
                        {this.allowRetry() &&
                            (this.isNetworkError() ||
                                !this.props.isLimitReached) && (
                                <div className="error-content">
                                    <h1
                                        className="error-title"
                                        ref={this.primaryFocusRef}
                                        tabIndex={-1}
                                    >
                                        {this.isNetworkError()
                                            ? t("idpal_network_error")
                                            : t(
                                                  "idpal_application_encountered_an_error"
                                              ) + t("idpal_please_try_again")}
                                    </h1>

                                    <CustomButton
                                        id={"retry"}
                                        label={t("idpal_try_again")}
                                        className={"btn error-cta"}
                                        handleClick={this.props.retryAction}
                                        actionDataLabel={
                                            ACTION.errorRetryButton
                                        }
                                    />
                                </div>
                            )}

                        {/* Max retries hit, or no function to retry, contact admin */}
                        {(!this.allowRetry() ||
                            (this.props.isLimitReached &&
                                !this.isNetworkError())) && (
                            <div className="error-content">
                                <h1
                                    className="error-title"
                                    ref={this.primaryFocusRef}
                                    tabIndex={-1}
                                >
                                    {t(
                                        "idpal_application_encountered_an_error"
                                    )}
                                </h1>

                                {!genericErrors() && (
                                    <p className="error-subtitle">
                                        {t("idpal_please_contact", {
                                            contact: this.getContact(),
                                        })}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        branding: state.config.profile,
        errors: state.submissionState.errors,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ countError }, dispatch);
}

export default withTranslation("translation")(
    connect(mapStateToProps, mapDispatchToProps)(Error)
);
